import React from 'react'

import styles from './PageHeader.module.scss'
import globalStyles from '../../styles/global.module.scss'

interface PageHeaderPropsInterface {
  children: any
}

export default (props: PageHeaderPropsInterface) => (
  <header
    className={`${globalStyles['full-width-item']} ${styles['container']}`}
  >
    <div className={globalStyles['section-item']}>{props.children}</div>
  </header>
)
